import Balance from './Balance'
import BalanceHeader from './BalanceHeader'
import BalanceHelp from './BalanceHelp'

export default {
  default: Balance,
  header: BalanceHeader,
  help: BalanceHelp,
}
